// Admin\src\components\users\UserDetails.js

import * as moment from 'moment'
import React, { useEffect, useState } from 'react'
import ImagePopup from '../../common/popups/Image';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getRequest } from '../../apis/functions';
import APIS from '../../apis/routes';
import { toaster } from '../../apis/commonFunctions';
import Button from '../../common/Button';
import Image from '../../common/Image';
import NoDataRow from '../../common/NoDataRow';

const UserDetails = () => {

    const nav = useNavigate()

    const [details, setDetails] = useState({
        emis: []
    });

    const [url, setUrl] = useState("")

    const { id } = useParams();

    async function fetchDetails() {
        try {
            const { data } = await getRequest(APIS.USER + "/" + id);
            if (data.status) {
                setDetails({ ...details, ...data.data })
            } else {
                toaster(data.message, false);
            }
        } catch (err) {
            // toaster(err, false)
            toaster(err.message, false)
        }
    }

    useEffect(() => {
        fetchDetails()
    }, [id]);

    return (
        <>
            <div className="pagetitle mb-5 mt-3" style={{ width: "fit-content" }}>
                User Details
            </div>
            <div className={"row"}>
                <div className="col-lg-2 col-md-2">
                    <div className="profile_image">
                        {/* <Image src={details?.profile_pic !== "" ? process.env.REACT_APP_IMAGE_URL + details?.profile_pic : "/user.jpg"} alt="" className="rounded-circle img-fluid" /> */}
                        <Image
                            src={details?.profile_pic ? details?.profile_pic : "/user.jpg"}
                            alt=""
                            className="rounded-circle img-fluid"
                        />
                    </div>
                </div>
                <div className="col-lg-10 col-md-10">
                    <ul className="profile_list p-0 row custom-css">
                        <div className="col-md-6"><li>
                            <div className="detail_wrapper">
                                <div className="small_heading">Fullname</div>
                                <div className="name mt-2">{details?.full_name !== "" ? details?.full_name : "N/A"}</div>
                            </div>
                        </li></div>
                        <div className="col-md-6"><li>
                            <div className="detail_wrapper">
                                <div className="small_heading">Username</div>
                                <div className="name mt-2">{details?.user_name !== "" ? details?.user_name : "N/A"}</div>
                            </div>
                        </li></div>
                        <div className="col-md-6"><li>
                            <div className="detail_wrapper">
                                <div className="small_heading">Phone</div>
                                <div className="name mt-2">
                                    {details?.phone_number && details?.country_code && details?.phone_number !== "" ?
                                        `${details.country_code} ${details.phone_number}` : "N/A"}
                                </div>
                            </div>
                        </li></div>

                        <div className="col-md-6"><li>
                            <div className="detail_wrapper">
                                <div className="small_heading">Email</div>
                                <div className="name mt-2">
                                    {details?.email && details?.email !== "" ? details.email : "N/A"}
                                </div>
                            </div>
                        </li></div>
                    </ul>
                </div>
            </div>
            <ImagePopup src={url} />
        </>
    )
}

export default UserDetails